module.exports = __webpack_public_path__ + "img/default-avatar.cb9d7ccf.png";